<template>
  <div>
      <div @click="logOk" id="map" ref="map" style="width: 100% !important; height: 350px; margin-bottom: 20px">
        <div class="grid items-center justify-center text-gray-light font-bold text-4xl md:text-6xl pt-36">Click to see map</div>
      </div>
    </div>
</template>

<script>
export default {
  name: "GoogleMapLuxuryHotelsComponent",
  props: ["hotels", "requestInput"],
  data() {
    return {
      isShow: false,
      notTriggered: true,
    };
  },
  mounted() {
  },
  methods: {
    logOk() {

    if (this.notTriggered) {
        this.initMap();
      }
      this.isShow = true;
      this.notTriggered=false;
    },
    initMap() {
      var bounds = this.getBounds();
      var $mapDiv = $("#map");
      var mapDim = {
        height: $mapDiv.height(),
        width: $mapDiv.width(),
      };

      var map = new google.maps.Map(this.$refs.map, {
        zoom: bounds ? this.getBoundsZoomLevel(bounds, mapDim) : 0,
        center: bounds ? bounds.getCenter() : new google.maps.LatLng(0, 0),
        streetViewControl: false,
      });

      this.loadMapMarkers(map);
    },
    getBounds() {
      const bounds = new google.maps.LatLngBounds();
      this.hotels.forEach((hotel) => {

        bounds.extend(new google.maps.LatLng(hotel.latitude, hotel.longitude));
      });
      return bounds;
    },

    getBoundsZoomLevel(bounds, mapDim) {
      var WORLD_DIM = { height: 256, width: 256 };
      var ZOOM_MAX = 15;

      function latRad(lat) {
        var sin = Math.sin((lat * Math.PI) / 180);
        var radX2 = Math.log((1 + sin) / (1 - sin)) / 2;
        return Math.max(Math.min(radX2, Math.PI), -Math.PI) / 2;
      }

      function zoom(mapPx, worldPx, fraction) {
        return Math.floor(Math.log(mapPx / worldPx / fraction) / Math.LN2);
      }

      var ne = bounds.getNorthEast();
      var sw = bounds.getSouthWest();

      var latFraction = (latRad(ne.lat()) - latRad(sw.lat())) / Math.PI;

      var lngDiff = ne.lng() - sw.lng();
      var lngFraction = (lngDiff < 0 ? lngDiff + 360 : lngDiff) / 360;

      var latZoom = zoom(mapDim.height, WORLD_DIM.height, latFraction);
      var lngZoom = zoom(mapDim.width, WORLD_DIM.width, lngFraction);

      return Math.min(latZoom, lngZoom, ZOOM_MAX);
    },

    loadMapMarkers(map) {
      var infowindow = new google.maps.InfoWindow();
      let pinShadow = new google.maps.MarkerImage(
        "http://chart.apis.google.com/chart?chst=d_map_pin_shadow",
        new google.maps.Size(40, 37),
        new google.maps.Point(0, 0),
        new google.maps.Point(12, 35)
      );
      var markers=[];
      let markerCluster = new MarkerClusterer(map, markers, {
            imagePath: 'https://cdn.rawgit.com/googlemaps/js-marker-clusterer/gh-pages/images/m',
            minimumClusterSize: 2,
            gridSize: 40,
            maxZoom: 7,
            ignoreHidden: true
        });

      let lastMarker = null;
      this.hotels.forEach((hotel) => {
        let marker = new google.maps.Marker({
          position: new google.maps.LatLng(hotel.latitude, hotel.longitude),
          map: map,
          icon: "/img/PU-36dp.png",
          shadow: pinShadow,
          name: hotel.name,
        });
        markers[hotel.hotelid] = marker;
       markerCluster.addMarker(marker);
        var currentLength = markers.length;

        let postData = {
          hotel_id: hotel.hotelid,
          min_price: hotel.min_night_price,
          stay_price: hotel.min_price,
          currency_code: hotel.currency_code,
        };

        google.maps.event.addListener(
          marker,
          "click",
          (function (map, marker, hotel, postData) {
            return function () {
              $.ajax({
                type: "POST",
                async: false,
                url: `/mapContinentDetailstw/${hotel.url_name}`,
                data: postData,
                success: (data) => {
                  infowindow.setContent(
                    "<div id='contenido_info' style='overflow:hidden;'>" +
                      data +
                      "</div>"
                  );
                  infowindow.maxWidth = 290;
                  infowindow.open(map, marker);
                },
              });
            };
          })(map, marker, hotel, postData)
        );
      });
    },
  },
};
</script>

<style scoped>
.gm-style .gm-style-iw-c {
  max-width: 290px !important;
  min-width: 290px !important;
}
</style>
